import { render } from "./myLuckydraw.vue?vue&type=template&id=3860cf86&scoped=true"
import script from "./myLuckydraw.vue?vue&type=script&lang=js"
export * from "./myLuckydraw.vue?vue&type=script&lang=js"

import "./myLuckydraw.vue?vue&type=style&index=0&id=3860cf86&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3860cf86"]])

export default __exports__